import { ShowArtifactRequestSchema, ShowArtifactResponseSchema } from './show-artifact.schema';
/**
 * Show Artifact Endpoint Contract
 * Retrieves a specific artifact by ID
 */ export const showArtifactContract = {
    method: 'GET',
    path: '/api/v2/artifact/:id',
    description: 'Retrieve a specific artifact by ID',
    requestSchema: ShowArtifactRequestSchema,
    responseSchema: ShowArtifactResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'Artifact not found'
        }
    }
};

//# sourceMappingURL=show-artifact.contract.js.map